import { memo } from 'react';
import { decorationLine, parseCaretText } from '../lib/format.js';

/**
 * Live in-game preview of a caret-tagged snippet (^1…^9, ^*, ^_, ^~, ^=, ^r).
 */
export const FormatPreview = memo(function FormatPreview({ content, className }) {
  const segments = parseCaretText(content);

  return (
    <div className={className}>
      {segments.map((seg, i) => (
        <span
          key={i}
          style={{
            color: seg.color,
            fontWeight: seg.bold ? 700 : 400,
            textDecorationLine: decorationLine(seg),
          }}
        >
          {seg.text}
        </span>
      ))}
    </div>
  );
});